import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import If from '../operador/if'


class Menu extends Component {

    render() {
        return (
            <ul className='sidebar-menu'>
                <MenuItem path='/' label='Dashboard' icon='dashboard' />
                <MenuTree label='Boleto/Carne' icon='edit'>
                    <MenuItem path='carnes'
                        label='Carnês' icon='book' />

                    <MenuItem path='boletos'
                        label='Boletos' icon='barcode' />

                    <If test={(this.props.usuario.adm)}>
                        <MenuItem path='unidades'
                            label='Unidades' icon='briefcase' />
                    </If>

                </MenuTree>
                <If test={(this.props.usuario.adm)}>
                    <MenuTree label='Usuario' icon='user'>
                        <MenuItem path='usuarios'
                            label='Usuários' icon='user' />
                    </MenuTree>

                    <MenuTree label='Automatização' icon='cogs'>
                        <MenuItem path='aut_carne'
                            label='Carnê' icon='book' />
                    </MenuTree>

                    <MenuItem path='configuracao'
                            label='Configuração' icon='cog' />
                </If>
            </ul>
        )
    }
}

const mapStateToProps = state => ({ usuario: state.auth.user })
const mapDispatchToProps = dispath => bindActionCreators({}, dispath)
export default connect(mapStateToProps, mapDispatchToProps)(Menu)


// WEBPACK FOOTER //
// ./src/common/template/menu.jsx